import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {},
	mobileBigView: {},
	value: {
		fontSize: "23px",
		lineHeight: 1.24,
		fontFamily: theme.fonts.bold,
		color: theme.palette.colors.darkSlateBlue,
	},
	priceWrapper: {
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	measure: {
		fontSize: "14px",
		lineHeight: 1.42,
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
		marginLeft: "4px",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		value: {
			fontSize: "16px",
		},
		measure: {
			fontSize: "12px",
			marginLeft: "4px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		value: {
			fontSize: "23px",
		},
		measure: {
			fontSize: "14px",
		},
		mobileBigView: {
			"& $value": {
				fontSize: "23px",
			},
		},
	},
});

const PriceComponent = ({ classes, mobileBigView, texts, value, measure, freeText }) => (
	<div
		className={classNames(classes.root, classes.priceWrapper, {
			[classes.mobileBigView]: mobileBigView,
		})}
	>
		<div>
			{freeText && !value ? (
				<span className={classes.value}>{texts.FREE}</span>
			) : (
				<>
					<span className={classes.value}>{!!value ? value : "-"}</span>
					{!!measure && <span className={classes.measure}>{measure}</span>}
				</>
			)}
		</div>
	</div>
);

export default withStyles(styles)(PriceComponent);
